export const LogoMark = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="15" y="15" width="34" height="34" transform="rotate(45 32 32)" fill="#351044" stroke="#7944C8" strokeWidth="3" />
    <rect x="27" y="27" width="10" height="10" transform="rotate(45 32 32)" fill="#F4C542" />
  </svg>
);

export default function Logo({ light = true }) {
  return (
    <span className="flex items-center gap-2.5">
      <LogoMark className="h-6 w-6" />
      <span
        className={`font-display text-2xl leading-none tracking-[0.08em] ${
          light ? "text-bone" : "text-ink"
        }`}
      >
        REQUIEM FEVER
      </span>
    </span>
  );
}
